import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { ErrorText } from './ErrorText';

interface ApiErrorTextProps {
  error?: unknown;
  fallbackKey?: string;
  size?: 'small' | 'medium';
  className?: string;
}

const ApiErrorText = ({
  error,
  fallbackKey = 'common.unknownError',
  size = 'medium',
  className,
}: ApiErrorTextProps) => {
  const { t } = useTranslation();

  let errorMessage: string;

  if (typeof error === 'string') {
    errorMessage = error;
  } else if (error instanceof AxiosError) {
    errorMessage = error.response?.data?.message || t(fallbackKey);
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else {
    errorMessage = t(fallbackKey);
  }

  return (
    <ErrorText size={size} className={className}>
      {errorMessage}
    </ErrorText>
  );
};

export { ApiErrorText };
